var default_styles_default = {
  "button_container": "MON0X",
  "button_text": "MpkJP",
  "button_size_content": "llxYD"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
